import React from "react";

function BOD() {
  return (
    <div>
      <section className="bod py-5" style={{ backgroundColor: "#f8f8f8" }}>
        <div className="container">
          <div className="headings1 text-center mb-5">
            <h6
              className="subtitle"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1200"
            >
              Our Team
            </h6>
            <h2
              className="main-heading"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="1200"
            >
              Meet Our Board Of Directors
            </h2>
          </div>
          <div className="row">
            <div
              className="col-md-12"
              style={{
                boxShadow: "0 0 8px 0 rgba(204, 204, 204, 0.9)",
                backgroundColor: "#fff",
              }}
            >
              <div className="">
                <div className="card mb-3 team-card">
                  <div className="row g-0 d-flex justify-content-between ">
                    
                    <div className="col-md-12">
                      <div className="card-body">
                        <h3 className="card-title fw-bold text-center">Assad Ali Lodhi</h3>
                        <p className="card-text justify-align ">
                          Mr. Lodhi is a Director at Inter Market Knit and is
                          regarded as a mentor to many people working in various
                          fields in Pakistan. Working and learning from him is a
                          privilege as he is always ready to help, guide and
                          advise. He has counselled and led many who have
                          achieved success in their respective industries. He is
                          considered as a promoter of sustainability and
                          believes that there is no task that is worth any work
                          without sustainability. <br />
                          <br />A graduate in Mechanical Engineering from one of
                          the leading universities in the country, University of
                          Engineering and Technology (UET), he has hands-on
                          experience in setting up an entire business.
                        </p>
                        <p>
                        He is well versed in Project Management, Risk Analysis,
                        Supply Chain Performance, Lean Manufacturing Systems,
                        Strategy Deployment and possesses very strong leadership
                        and people’s management skills. Being instrumental in
                        bringing creativity into life, Mr. Lodhi is a leader in
                        change management who has successfully cultivated the
                        paradigm shift.
                      </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-12 mt-4"
              style={{
                boxShadow: "0 0 8px 0 rgba(204, 204, 204, 0.9)",
                backgroundColor: "#fff",
              }}
            >
              <div className="">
                <div className="card mb-3 team-card">
                  <div className="row g-0 d-flex justify-content-between ">
                    <div className="col-md-12">
                      <div className="card-body">
                        <h3 className="card-title fw-bold text-center">Alia Lodhi</h3>
                        <p className="card-text justify-align">
                          Ms. Lodhi is a distinguished professional with over 2
                          decades of extensive experience in textile industry.
                          Currently she serves on the Board of Inter Market
                          along with being the company secretary. In the
                          business operations she is heading the HR and
                          Compliance department.
                          <br />
                          <br /> She has an Engineering Degree and holds an MBA
                          from LUMS. She is a certified Board Member having
                          completed the BOD training program from LUMS.
                        </p>
                        <p>
                        Ms Lodhi has successfully governed and lead corporate
                        negotiations at business executive level managing
                        complex transactions of share transfers, acquisition,
                        and loan settlement areas. She handled large projects in
                        her career including the setting up of the first ever
                        offshore call centre in Pakistan. In the realms of HR
                        and compliance, Ms. Lodhi has trained and developed many
                        professionals who are serving successfully in many local
                        and international organizations. She is a pioneer in
                        developing policies and implementing HR standards in
                        local textile organizations. She is a certified
                        Compliance Professional in numerous areas of compliance
                        and sustainability from CSI Singapore.
                        <br />
                        <br />
                        During her leadership role with Inter Market, several
                        international businesses were able to develop trust in
                        the locally managed companies in Pakistan. Ms. Lodhi is
                        revered as a role model for women in the SME sector
                        where she has contributed significantly for more than
                        two decades. She actively advocates for the integration
                        and advancement of women in the workplace, establishing
                        herself as a thought leader. Her efforts have
                        established her as a role model and thought leader in
                        empowering women within the textile industry and beyond.
                      </p>
                      </div>
                    </div>
                      
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BOD;
